import { hotRanking } from '@/pages/home/data';

const rankTone: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-foreground-950',
  3: 'bg-secondary-500 text-background-50',
};

export default function HotRanking() {
  return (
    <section id="hot" className="scroll-mt-20 bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs font-medium tracking-[0.24em] text-primary-600">HOT SEARCH</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              热门查询榜单
            </h2>
          </div>
          <span className="inline-flex items-center gap-2 self-start md:self-auto h-9 px-3.5 rounded-full bg-primary-100 text-primary-800 text-xs font-medium">
            <i className="ri-fire-line"></i>
            热度实时更新
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
          {hotRanking.map((item) => (
            <a
              key={item.rank}
              href="#guide"
              className="group flex items-center gap-4 bg-background-50 border border-background-200 rounded-xl p-3 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <span
                className={`shrink-0 w-9 h-9 rounded-lg font-heading font-bold text-lg flex items-center justify-center ${
                  rankTone[item.rank] ?? 'bg-background-200 text-foreground-700'
                }`}
              >
                {item.rank}
              </span>

              <div className="shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-background-100">
                <img
                  src={item.cover}
                  alt={`${item.title} 配图`}
                  title={`${item.title} 蘑菇视频攻略`}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-1.5 text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-1.5 flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-line-chart-line text-accent-600"></i>
                  <span>热度 {item.heat.toLocaleString()}</span>
                </div>
              </div>

              <span className="shrink-0 w-8 h-8 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-up-line text-lg"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}